var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoEquipamento2Active(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons/32x32/equipamento") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/32x32/equipamento",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    fillOpacity: 0,
    fill: "none",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.000000, 5.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,18 C2.8954305,18 2,17.1045695 2,16 L2,2 C2,0.8954305 2.8954305,0 4,0 L26,0 C27.1045695,0 28,0.8954305 28,2 L28,16 C28,17.1045695 27.1045695,18 26,18 M6,3 L24,3 C24.5522847,3 25,3.44771525 25,4 L25,14 C25,14.5522847 24.5522847,15 24,15 L6,15 C5.44771525,15 5,14.5522847 5,14 L5,4 C5,3.44771525 5.44771525,3 6,3 Z M30,19 L30,18 L19,18 C19,18.5522847 18.5522847,19 18,19 L12,19 C11.4477153,19 11,18.5522847 11,18 L0,18 L0,19 M30,18 L30,20 C30,21.1045695 29.3604068,22 28.5714286,22 L1.42857143,22 C0.639593215,22 0,21.1045695 0,20 L0,18",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoEquipamento2Active);
export default __webpack_public_path__ + "static/media/PictoEquipamento2Active.53c74a545239afd4bab8a4a8aa91ae1a.svg";
export { ForwardRef as ReactComponent };